import * as Yup from "yup";

import { Button, Card, Col, Row } from "@themesberg/react-bootstrap";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import {
  getAllDataOfDispenserSrNo,
  getCalibrationDetailsGetData,

  postCalibrationstartDetailscloseofimages,
  postGetotpDetailscalistart
} from "../../Service/AllServicesAPI";
import { fetchOtp, deleteOtp } from "../../Service/AllProductionAPI"
import {
  getCustomerList,
  getDealerList,
  getServiceEngineerList,
} from "../master/AllUserDropDown";

import DatePicker from "react-datepicker";
import EndingARKCalibration from "./EndingARKCalibration";
// import NotScanned from "../NotScanned";
import Select from "react-select";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faBackward } from "@fortawesome/free-solid-svg-icons";

import TextError from "../TextError";
import ToolTip from "../ToolTip";
import moment from "moment-timezone";
import swal from "sweetalert";
import { useLocation, Link } from "react-router-dom";
import Toast from 'react-bootstrap/Toast';
// import OtpFormBased from "../../components/OtpFormBased";


export default () => {
  const [show, setShow] = useState(false);
  const [showM, setShowM] = useState(false);
  const handleShow = () => setShowM(true);
  const handleClose = () => setShowM(false);
  const [customerName, setCustomerName] = useState([]);
  const [csd, setCsd] = useState([1]);
  const [mre, setMre] = useState([1]);
  const [lkd, setLkd] = useState([1]);
  // newly added board vr and printer
  const [pvr, setPvr] = useState([1]);
  const [prn, setPrn] = useState([1]);

  const location = useLocation();
  const [workOrder, setWorkOrder] = useState("");
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [processData, setProcessData] = useState([]);
  const [dispenserSrNo, setDispenserSrNo] = useState("");
  let type = null;
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [customerMblNo, setCustomerMblNo] = useState("");
  const [dealerNm, setDealerNm] = useState("");
  const [customerNm, setCustomerNm] = useState("");
  const [oprationType, setOprationType] = useState("");
  const [subOprationType, setSubOprationType] = useState("");

  const [serviceEngineerNm, setServiceEngineerNm] = useState("");
  const [serviceEngineerId, setServiceEngineerId] = useState("");
  const [siteT, setSiteT] = useState("");
  const [Desc, setDesc] = useState("");
  const [userMblNo, setUserMblNo] = useState("");
  const [dealerId, setDealerId] = useState([]);
  const [dealerMblNo, setDealerMblNo] = useState("");
  let today = new Date();
  let todayDate =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  console.log("todayDate :-", todayDate);
  const [dealerName, setDealerName] = useState([]);
  const [serviceEngineerName, setServiceEngineerName] = useState([]);
  const [isLoaded, setisLoaded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [newData, setNewData] = useState("");
  const [curreLocation, setCurreLocation] = useState({});
  const [prodT, setProdT] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [selectedTime, setSelectedTime] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [disabled, setDisabled] = useState(false);
  const [base64Image, setBase64Image] = useState("");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [B64ICertificateDatePhoto, setB64ICertificateDatePhoto] = useState("");
  const [B64ICalibrationCert, setB64ICalibrationCert] = useState("");
  const [B64ICertificateSignature, setB64ICertificateSignature] = useState("");
  const [B64IDigitalSignature, setB64IDigitalSignature] = useState("");
  const [B64ISiteReportU, setB64ISiteReportU] = useState("");
  const [B64ICalibrationLV, setB64ICalibrationLV] = useState("");
  const [B64ISitePhoto, setB64ISitePhoto] = useState("");
  const [calibrationCertError, setCalibrationCertError] = useState('');
  const [calibrationCertDateError, setCalibrationCertDateError] = useState('');
  const [CertificateSignatureError, setCertificateSignatureError] = useState('');
  const [DigitalSignatureError, SetDigitalSignatureError] = useState('');
  const [UploadSitereporterror, SetUploadSitereporterror] = useState('');
  const [CalibrationLogViewPhoto, SetCalibrationLogViewPhoto] = useState('');
  const [sitephotoupload, Setsitephotoupload] = useState('');
  const [arkNo, setArkNo] = useState("");
  const [volumeTotalizer, setVolumeTotalizer] = useState("");
  const [jobNo, setJobNo] = useState("");
  const [inspectorName, setInspectorName] = useState("");
  const [inspectorMobileNo, setInspectorMobileNo] = useState("");
  const [roManagerName,setroManagerName]=useState("");
  const [roManagerEmail,setroManagerEmail]=useState("");
  const [roManagerMobNo,setroManagerMobNo]=useState("");
  const [fkRoManagerId,setfkRoManagerId]= useState("");
  const [error, setError] = useState('');
  const [closeComp, SetCloseComp] = useState(true);
  // loading text in button 
  const [loadingbutton, setLoadingbutton] = useState(false);
  // verify  and upload image form toggle states
  const [isVerifyEnabled, setVerifyEnabled] = useState(true);
  const [isOtpEnabled, setOtpEnabled] = useState(true);

  // disable and enable get otp button after 1 minutues
  const [isOtpdisable, setOtpdisable] = useState(true);

  // image validation to keep button disable of close calibration start
  const [iscalibrationstartcloseEnables, setButtonDisabled] = useState(true);
  //
  const [CloseCalibutton, setCloseCalibutton] = useState(false)

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const [otpData, setOtpData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(true);

  const [arkError, setArkError] = useState("");


  /* declaration of validationSchema
validation (based on the object schema provided by Yup) and display of validation errors */
  const validationSchema = Yup.object().shape({
    arkNo: Yup.string().required("Required *"),
    // subOprationType: Yup.string().required("Required *"),
    volumeTotalizer: Yup.string().required("Required *"),
    // inspectorName: Yup.string().required("Required *"),
    // inspectorMobileNo: Yup.string().required("Required *"),
    jobNo: Yup.string().required("Required *"),
    remark: Yup.string().required("Required *"),
    calibrationCertificate: Yup.mixed()
      .test("fileType", "Please select a PDF file", (value) => {
        return value && value.type === "application/pdf";
      }),
      // .required("Pdf is required"),
    certificateDatePhoto: Yup.mixed()
      // .required("Image is required")
      .test("is-image", "Only image files are allowed", (value) => {
        if (!value) return false;
        return (
          value &&
          [
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/webp",
            "image/jpg",
          ].includes(value.type)
        );
      }),
    certificateSignature: Yup.mixed()
      // .required("Image is required")
      .test("is-image", "Only image files are allowed", (value) => {
        if (!value) return false;
        return (
          value &&
          [
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/webp",
            "image/jpg",
          ].includes(value.type)
        );
      }),
    digitalSignature: Yup.mixed()
      // .required("Image is required")
      .test("is-image", "Only image files are allowed", (value) => {
        if (!value) return false;
        return (
          value &&
          [
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/webp",
            "image/jpg",
          ].includes(value.type)
        );
      }),
    siteReportUpload: Yup.mixed()
      // .required("Image is required")
      .test("is-image", "Only image files are allowed", (value) => {
        if (!value) return false;
        return (
          value &&
          [
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/webp",
            "image/jpg",
          ].includes(value.type)
        );
      }),
    calibrationLogView: Yup.mixed()
      // .required("Image is required")
      .test("is-image", "Only image files are allowed", (value) => {
        if (!value) return false;
        return (
          value &&
          [
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/webp",
            "image/jpg",
          ].includes(value.type)
        );
      }),
    sitePhoto: Yup.mixed()
      .required("Image is required")
      .test("is-image", "Only image files are allowed", (value) => {
        if (!value) return false;
        return (
          value &&
          [
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/webp",
            "image/jpg",
          ].includes(value.type)
        );
      }),
  });

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        var form = event.target.form;
        var index = Array.prototype.indexOf.call(form, event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    });
  }, []);

  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value);
  };

  const formatTimeTo12Hour = (time24) => {
    const [hour, minute, second] = time24.split(":");
    const parsedHour = parseInt(hour, 10);
    const period = parsedHour >= 12 ? "PM" : "AM";
    const formattedHour = parsedHour > 12 ? parsedHour - 12 : parsedHour;
    return `${formattedHour}:${minute}:${second} ${period}`;
  };

  const displayFormattedTime = selectedTime
    ? formatTimeTo12Hour(selectedTime)
    : "";

  const modalToggle = () => {
    setShowModal(handleShow);
  };

  const getPassedData = () => {
    if (location.state && location.state.data) {
      sessionStorage.setItem("getCalibrationDispenserData", JSON.stringify(location.state.data));
      return location.state.data;
    }
    const saved = sessionStorage.getItem("getCalibrationDispenserData");
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        return null;
      }
    }
    return null;
  };

  useEffect(() => {
    // Function call to get customers,Dealers and  Service Engineers list
    getCustomersList();
    getServiceEngineersList();
    getDealersList();
    getCalibrationAllDetails();
    geolocation();
    if (role === "service engineer") {
      const data = getPassedData();
      if (data) {
        setWorkOrder(data.workOrderSerialNo);
        setDispenserSrNo(data.generateUniqueDispenserNo);
        // getDataScanOrNot(data.generateUniqueDispenserNo);
        getDataDispenSrNo(data.generateUniqueDispenserNo);
        setCustomerNm(data.customerName); //siteType
        setCustomerMblNo(data.customerMobNo);
        setServiceEngineerNm(data.serviceEngineerName);
        setUserMblNo(data.serviceEngineerMobNo);
        setDealerNm(data.dealerName);
        setDealerMblNo(data.dealerMobNo);
        setServiceEngineerId(data.fkServiceEngineerId);
        setSelectedCustomerId(data.fkCustomerId);
        setDealerId(data.fkDealerId);
        setSiteT(data.siteType);
        setOprationType(data.oprationType);
        setSubOprationType(data.subOprationType);
        setroManagerName(data.roManagerName);
        setroManagerEmail(data.roManagerEmail);
        setroManagerMobNo(data.roManagerMobNo);
        setfkRoManagerId(data.fkRoManagerId);
      }
    }
  }, []);

  const validateMobile = (value) => {
    let error;
    if (!value) {
      error = "Mobile number is required";
    } else if (!/^[0-9\s]+$/.test(value)) {
      error = "Enter numbers only";
    } else {
      const cleanedNumber = value.replace(/\s/g, ""); // Remove spaces
      if (!/^\d{10}$/.test(cleanedNumber)) {
        error = "Mobile number must be exactly 10 digits";
      } else if (!/^[6-9]\d{9}$/.test(cleanedNumber)) {
        error = "Invalid mobile number";
      }
    }
    return error;
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setInspectorMobileNo(value);
    const validationError = validateMobile(value);
    setError(validationError);
  };

  const handleBlur = () => {
    const validationError = validateMobile(inspectorMobileNo);
    setError(validationError);
  };

  // Function declaration of get customers list
  const getCustomersList = async () => {
    await getCustomerList().then((result) => {
      setCustomerName(result);
    });
  };
  // Function declaration of get Service Engineers list
  const getServiceEngineersList = async () => {
    await getServiceEngineerList().then((result) => {
      setServiceEngineerName(result);
    });
  };

  const getDealersList = async () => {
    await getDealerList().then((result) => {
      setDealerName(result);
    });
  };

  const getCalibrationAllDetails = async () => {
    const data = getPassedData();
    if (!data || !data.workOrderSerialNo) return;
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    let workOSNo = data.workOrderSerialNo;
    await getCalibrationDetailsGetData(workOSNo, headers)
      .then((result) => {
        console.log(
          "getCalibrationDetailsGetData result for check :-",
          result.data
        );
        if (result.data.sitePhoto) {  // addes new digitalsignature for validation
          setNewData(result.data);
          modalToggle();
        }
      })
      .catch((error) => {
        console.log("getCalibrationDetailsGetData error for check :-", error);
      });
  };

  const geolocation = () => {
    if (!navigator.geolocation) {
      // swal("Failed", "Geolocation is not supported in your browser", "warning");
      console.log("Geolocation is not supported in your browser");
    } else {
      navigator.geolocation.getCurrentPosition((position) => {
        console.log("Position :-", position);
        const { latitude, longitude } = position.coords;
        console.log("latitude, longitude :-", latitude, longitude);
        setCurreLocation({ latitude, longitude });
      });
    }
  };

  const alertMessage = () => {
    Swal.fire({
      position: "top-center",
      title: "Please scan the device and get the data from dispenser.",
      showConfirmButton: false,
      timer: 3000,
    });
  };


  const getDataDispenSrNo = (disSrNo) => {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    console.log("dispenserSrNo :-", disSrNo);
    getAllDataOfDispenserSrNo(disSrNo, headers)
      .then((result) => {
        console.log("getAllDataOfDispenSrNo result :-", result);
        setProdT(result.data.productType);
      })
      .catch((error) => {
        console.log("getAllDataOfDispenSrNo error :-", error);
      });
  };

//   const handleArkChange = (e) => {
//   const value = e.target.value.toUpperCase();


//   if (!/^[A-Z0-9]*$/.test(value)) return;

  
//   if (value.length > 10) return;

//   setArkNo(value);

//   // custom validation
//   if (value.length < 6) {
//     setArkError("ARK No. length must be exactly 10 ");
//   } else {
//     setArkError("");
//   }
// };


  // Added new boards in modelQty (prn and pvr)  with other boards (csd,mre,lkd) and (Mcu,Tot)
  const modelQty = [
    {
      modelNo: "1111",
      csd: [1],
      mre: [1],
      lkd: [1],
      prn: [1],
      pvr: [1],
    },
    {
      modelNo: "1121",
      csd: [1, 1],
      mre: [1],
      lkd: [1],
      prn: [1],
      pvr: [1],
    },
    {
      modelNo: "1222",
      csd: [1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2222",
      csd: [1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2422",
      csd: [1, 1],
      mre: [1, 1, 1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "3622",
      csd: [1, 1],
      mre: [1, 1, 1, 1, 1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "4822",
      csd: [1, 1],
      mre: [1, 1, 1, 1, 1, 1, 1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "1242",
      csd: [1, 1, 1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2242",
      csd: [1, 1, 1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "1444",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2444",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "3644",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "4844",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1, 1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
  ];

  const startCalibration = [
    { value: "Nozzle 1", label: "Nozzle 1" },
    { value: "Nozzle 2", label: "Nozzle 2" },
    { value: "Nozzle 3", label: "Nozzle 3" },
    { value: "Nozzle 4", label: "Nozzle 4" },
    { value: "Nozzle 5", label: "Nozzle 5" },
    { value: "Nozzle 6", label: "Nozzle 6" },
    { value: "Nozzle 7", label: "Nozzle 7" },
    { value: "Nozzle 8", label: "Nozzle 8" },
  ];



  const calibrationCert = (e) => {
    console.log("calibrationCert :-", e.target.files[0]);
    const file = e.target.files[0];
    console.log("calibrationCert file :-", file);

    if (file) {

      if (file.type !== "application/pdf") {

        setCalibrationCertError("Please upload a PDF file.");
        return;
      }


      const reader = new FileReader();
      reader.onload = () => {
        setB64ICalibrationCert(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };



  const certificateDatePhoto = (e) => {
    console.log("certificateDatePhoto :-", e.target.files[0]);
    const file = e.target.files[0];
    console.log("certificateDatePhoto file :-", file);

    if (file) {
      // Check if the file is an image
      if (!file.type.startsWith('image/')) {
        // If the file is not an image, set the error message
        setCalibrationCertDateError("Please upload an image file.");
        setButtonDisabled(true);
        return;
      }

      // Check if the image size exceeds 100 KB
      if (file.size > 100 * 1024) { // 100 KB in bytes
        // If the image size exceeds 100 KB, set the error message
        setCalibrationCertDateError(<p>
          The selected image size exceeds 100 KB. Please reduce the size of the image using this link:{" "}
          <a href="https://image.pi7.org/reduce-image-size-in-kb" target="_blank"> <span style={{ color: 'blue', textDecoration: 'none' }}>https://image.pi7.org/reduce-image-size-in-kb</span></a>.
        </p>);
        setButtonDisabled(true);
        return;
      }

      // If the file is an image and size is within limits, proceed with reading it
      const reader = new FileReader();
      reader.onload = () => {
        setB64ICertificateDatePhoto(reader.result);
        setButtonDisabled(false);
      };
      reader.readAsDataURL(file);
    }
  };



  const certificateSignature = (e) => {
    console.log("certificateSignature :-", e.target.files[0]);
    const file = e.target.files[0];
    console.log("certificateSignature file :-", file);

    if (file) {

      if (!file.type.startsWith('image/')) {

        setCertificateSignatureError("Please upload an image file.");
        setButtonDisabled(true);
        return;
      }


      if (file.size > 100 * 1024) {

        setCertificateSignatureError(<p>
          The selected image size exceeds 100 KB. Please reduce the size of the image using this link:{" "}
          <a href="https://image.pi7.org/reduce-image-size-in-kb" target="_blank"> <span style={{ color: 'blue', textDecoration: 'none' }}>https://image.pi7.org/reduce-image-size-in-kb</span></a>.
        </p>);
        setButtonDisabled(true);
        return;
      }

      // If the file is an image and size is within limits, proceed with reading it
      const reader = new FileReader();
      reader.onload = () => {
        setB64ICertificateSignature(reader.result);
      };
      reader.readAsDataURL(file);
      setButtonDisabled(false);
    }
  };



  const digitalSignature = (e) => {
    console.log("digitalSignature :-", e.target.files[0]);
    const file = e.target.files[0];
    console.log("digitalSignature file :-", file);

    if (file) {

      if (!file.type.startsWith('image/')) {

        SetDigitalSignatureError("Please upload an image file.");
        setButtonDisabled(true);
        return;
      }


      if (file.size > 100 * 1024) {

        SetDigitalSignatureError(
          <p>
            The selected image size exceeds 100 KB. Please reduce the size of the image using this link:{" "}
            <a href="https://image.pi7.org/reduce-image-size-in-kb" target="_blank"> <span style={{ color: 'blue', textDecoration: 'none' }}>https://image.pi7.org/reduce-image-size-in-kb</span></a>.
          </p>
        );
        setButtonDisabled(true);
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        setB64IDigitalSignature(reader.result);
      };
      reader.readAsDataURL(file);
      setButtonDisabled(false);
    }
  };



  const siteReportU = (e) => {
    console.log("siteReportU :-", e.target.files[0]);
    const file = e.target.files[0];
    console.log("siteReportU file :-", file);

    if (file) {
      // Check if the file is an image
      if (!file.type.startsWith('image/')) {
        // If the file is not an image, set the error message
        SetUploadSitereporterror("Please upload an image file.");
        setButtonDisabled(true);
        return;
      }

      // Check if the image size exceeds 100 KB
      if (file.size > 100 * 1024) { // 100 KB in bytes
        // If the image size exceeds 100 KB, set the error message
        SetUploadSitereporterror(<p>
          The selected image size exceeds 100 KB. Please reduce the size of the image using this link:{" "}
          <a href="https://image.pi7.org/reduce-image-size-in-kb" target="_blank"> <span style={{ color: 'blue', textDecoration: 'none' }}>https://image.pi7.org/reduce-image-size-in-kb</span></a>.
        </p>);
        setButtonDisabled(true);
        return;
      }

      // If the file is an image and size is within limits, proceed with reading it
      const reader = new FileReader();
      reader.onload = () => {
        setB64ISiteReportU(reader.result);
      };
      reader.readAsDataURL(file);
      setButtonDisabled(false);
    }
  };



  const calibrationLV = (e) => {
    console.log("sitePhoto :-", e.target.files[0]);
    const file = e.target.files[0];
    console.log("sitePhoto file :-", file);

    if (file) {

      if (!file.type.startsWith('image/')) {

        SetCalibrationLogViewPhoto("Please upload an image file.");
        setButtonDisabled(true);
        return;
      }

      if (file.size > 100 * 1024) {

        SetCalibrationLogViewPhoto(<p>
          The selected image size exceeds 100 KB. Please reduce the size of the image using this link:{" "}
          <a href="https://image.pi7.org/reduce-image-size-in-kb" target="_blank"> <span style={{ color: 'blue', textDecoration: 'none', listStyle: 'node' }}>https://image.pi7.org/reduce-image-size-in-kb</span></a>.
        </p>);
        setButtonDisabled(true);
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        setB64ICalibrationLV(reader.result);
      };
      reader.readAsDataURL(file);
      setButtonDisabled(false);
    }
  };


  const sitePhotoI = (e) => {
    console.log("sitePhoto :-", e.target.files[0]);
    const file = e.target.files[0];
    console.log("sitePhoto file :-", file);

    if (file) {

      if (!file.type.startsWith('image/')) {

        Setsitephotoupload("Please upload an image file.");
        setButtonDisabled(true);
        return;
      }

      if (file.size > 100 * 1024) {

        Setsitephotoupload(<p>
          The selected image size exceeds 100 KB. Please reduce the size of the image using this link:{" "}
          <a href="https://image.pi7.org/reduce-image-size-in-kb" target="_blank"> <span style={{ color: 'blue', textDecoration: 'none', listStyle: 'node' }}>https://image.pi7.org/reduce-image-size-in-kb</span></a>.
        </p>);
        setButtonDisabled(true);
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        setB64ISitePhoto(reader.result);
      };
      reader.readAsDataURL(file);
      setButtonDisabled(false);
    }
  };





  const uploadImg = (e) => {
    console.log("uploadImg :-", e.target.files[0]);
    const file = e.target.files[0];
    console.log("file :-", file);
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
      setUploadedImage(file);
    }
  };



  // this function created for resete the calibration start form  on click of "No" button

  const HandleresetForm = () => {

    Swal.fire({
      title: 'Are you sure?',
      text: 'This will reset the form ',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reset it!'
    }).then((result) => {
      if (result.isConfirmed) {

        window.location.reload();
      }
    });
  };


  const token = sessionStorage.getItem("token");
  const fkUserId = sessionStorage.getItem("pkUserId");

  const fetchOtpFromApi = async () => {
    if (!fkUserId || !token) {
      console.error("Missing fkUserId or token in sessionStorage.");
      return;
    }

    try {
      setLoading(true);
      const fetchedData = await fetchOtp(fkUserId, token);
      console.log("Fetched OTP Data (Navbar):", fetchedData);

      if (fetchedData?.otp) {
        setOtpData(fetchedData);
      } else {
        setOtpData(null);
        console.warn("No OTP data found.");
      }
    } catch (error) {
      console.error("Error fetching OTP:", error);
    } finally {
      setLoading(false);
    }
  };

  // new get otp without delay response and please wait popup message
  const HandleSendOtpcalistart = async () => {
    console.log("ARK no. checking", arkNo);

    setLoadingbutton(true)
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    const payload = {
      workOrderSerialNo: workOrder,
      productType: prodT,
      generateUniqueDispenserNo: dispenserSrNo,
      arkNo: arkNo,
      oprationType: oprationType,
      subOprationType: subOprationType,
      volumeTotalizer: volumeTotalizer,
      jobNo: jobNo,
      // inspectorName: inspectorName,
      // inspectorMobileNo: inspectorMobileNo,
      calibrationDate: moment(startDate, "yyyy-MM-DD").format("yyyy-MM-DD"),
      calibrationTime: moment(displayFormattedTime, "hh:mm:ss A").format("hh:mm:ss A"),
      fkCustomerId: selectedCustomerId,
      customerName: customerNm,
      customerMobileNo: customerMblNo,
      roManagerEmail:roManagerEmail,
      roManagerMobNo:roManagerMobNo,
      fkRoManagerId  :fkRoManagerId,
      roManagerName:roManagerName,
      siteType: siteT,
      fkDealerId: dealerId,
      dealerName: dealerNm,
      description: Desc,
      dealerMobileNo: dealerMblNo,
      fkServiceEngineerId: serviceEngineerId,
      serviceEngineerName: serviceEngineerNm,
      serviceEngineerMobNo: userMblNo,
      longitude: curreLocation.longitude,
      latitude: curreLocation.latitude,
    };

    setOtpdisable(true);


    try {
      const response = await postGetotpDetailscalistart(payload, headers);



      const { message, status } = response.data;

      if (status === 200) {
        if (message === "First Generate ARK ON Dispenser Then, SCAN.") {
          swal("", message, "info");
        } else if (message === "Scanning Required..") {
          swal("", message, "warning");
        }
        else if (message === "ARK verification Failed") {
          swal("Failed", message, "error");
        }
        else if (message === "dispenser data is not scanned for this work order calibration 1") {
          swal("", "Dispenser data is not scanned for this work order", "error");
        }
        else if (message === "PKI Server is down..") {
          swal("", "PKI Server is down..", "info");
        }
        else if (message === "INVALID Operation Type And SubOperation Type..") {
          swal("Warning", "INVALID Operation Type And SubOperation Type..", "warning");
        }
        else if (message === "Calibration details job Work Order is Not Valid") {
          swal("Failed", "Calibration details job Work Order is Not Valid", "error");
        }
        else if (message === "Your Scanning for wrong Dispenser Serial Number..") {
          swal("", "Your Scanning for wrong Dispenser Serial Number...", "error");
        } else if (message === "Calibration details added successfully") {
          swal("Great", "Calibration details added successfully", "success");


          fetchOtpFromApi()
          setOtpEnabled(true);
          setOtpdisable(false);

          setLoadingbutton(false)
          setTimeout(() => {
            setOtpdisable(true);
          }, 60000);
        } else {
          swal("Error", "Unexpected response message", "error");
        }
      } else {
        swal("Error", "Unexpected status code", "error");
      }
    } catch (error) {

      console.log("Error sending OTP:", error);
      swal("Failed", "Error sending OTP", "error");
    }
    finally {

      setLoadingbutton(false)
    }
  };


  const handleDeleteOtp = async () => {
    if (!otpData?.pkFieldotpId) {
      console.error("OTP ID not found.");
      return;
    }

    try {
      setLoading(true);
      const result = await deleteOtp(otpData.pkFieldotpId);

      if (result.success) {
        console.log("OTP deleted successfully.");
        setOtpData(null); // Remove from UI
      } else {
        alert("Failed to delete OTP.");
      }
    } catch (error) {
      console.error("Error deleting OTP:", error);
    } finally {
      setLoading(false);
    }
  };





  // submiting the calibration start form with images,pdf, dispesner number and workorder serial number

  const Handlesubmitcalistart = async (values, { resetForm }) => {
    try {
      setDisabled(true);
      // payload 
      let data = {
        workOrderSerialNo: workOrder,
        generateUniqueDispenserNo: dispenserSrNo,
        calibrationCertificate: B64ICalibrationCert,
        certificateDatePhoto: B64ICertificateDatePhoto,
        certificateSignature: B64ICertificateSignature,
        digitalSignature: B64IDigitalSignature,
        siteReportUpload: B64ISiteReportU,
        calibrationLogView: B64ICalibrationLV,
        sitePhoto: B64ISitePhoto,
        remark: values.remark,
      };
      console.log("getCalibrationDispenser data :-", data);
      let token = sessionStorage.getItem("token");
      let headers = { Authorization: `Bearer ${token}` };



      await postCalibrationstartDetailscloseofimages(data, headers)
        .then((result) => {
          console.log("postCalibrationDetails result :-", result);
          setisLoaded(false);

          const message = result.data.message;

          if (message === "Data saved..") {
            swal("Great", "Data saved successfully..", "success");
            handleDeleteOtp()
            SetCloseComp(false)
            setIsButtonDisabled(true);
            setTimeout(() => {
              // window.location.href = "serviceModule/verification-calibration-list";
              window.location.reload()
            }, 3000);


          } else {
            swal("Failed", "Wrong data entered...", "error");
            setCloseCalibutton(true)

          }

        })
        .catch((error) => {
          console.log("postCalibrationDetails error :-", error);
          setisLoaded(false);
          if (error.response.status === 400) {
            swal("Failed", `${error.response.data.message}`, "error");
          } else if (error.response.data.status === 500) {
            swal("Failed", `${error.response.data.message}`, "error");

          } else {
            swal("Failed", "Failed to close Calibration start", "error");
          }
        });
    } catch (error) {
      console.log(error);
      swal("Failed", "Something went wrong", "error");
      setCloseCalibutton(true)
    }
  }

  return (
    <Formik
      initialValues={{
        workOrderSerialNo: "",
        generateUniqueDispenserNo: "",
        calibrationCertificate: "",
        certificateDatePhoto: "",
        certificateSignature: "",
        digitalSignature: "",
        siteReportUpload: "",
        calibrationLogView: "",
        sitePhoto: "",
        remark: "",
      }}
      // validationSchema={validationSchema}
      onSubmit={Handlesubmitcalistart}

    >
      {(formik) => {
        const { isValid, dirty, isSubmitting, handleSubmit, values } = formik;
        // const isVerifyButtonEnabled = arkNo;
        const isgetotpButtonEnabled =   arkNo.length === 6 &&
  !arkError  && jobNo  && startDate && displayFormattedTime && Desc && volumeTotalizer;
        const iscalibrationstartcloseEnable = values.sitePhoto &&
          values.remark &&   arkNo.length === 6 &&
  !arkError  && jobNo  && startDate && displayFormattedTime;
        // const isFormValid = !validateMobile(inspectorMobileNo);
        return (
          <>
            {showM && (
              <EndingARKCalibration
                status={showM}
                handleClose={handleClose}
                someData={newData}

              />
            )}
            <div className="d-flex mb-2">
              <Link
                to="verification-calibration-list"
                className="fieldLink btn btn-primary"
              >
                <FontAwesomeIcon icon={faAngleLeft} className="me-2" />{" "}
                My Jobs
                <span className="icon icon-small ms-1"></span>
              </Link>
            </div>
            <Card border="light" className="bg-white shadow-sm mb-4">
              <Card.Body>
                {!showM ? (
                  <>

                    <h5 className="head mb-4">Submit Calibration Start</h5>
                    {/* {closeComp?
                      <OtpFormBased/>:""} */}

                    {/* {otpData?.template && showToast ? (
                      <Toast
                        onClose={() => setShowToast(false)}
                        show={showToast}
                        delay={1004456646400} 
                        autohide
                        style={{
                          position: 'absolute',
                          right: '20px',
                          top: '520px',
                          marginBottom: '20px',
                          zIndex: '10000',
                          backgroundColor: '#007bff',
                          color: 'white',
                        }}
                      >
                        <Toast.Header>
                          <img
                            src="holder.js/20x20?text=%20"
                            className="rounded me-2"
                            alt=""
                          />
                          <strong className="me-auto text-black">Calibration Start OTP Notification</strong>
                        </Toast.Header>
                        <Toast.Body>{otpData.template}</Toast.Body>
                      </Toast>
                    ) : null} */}
                    <Form>
                      <Row>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Work Order No.
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              name="workOrderNo"
                              placeholder="Work Order No."
                              value={workOrder}
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Dispenser Serial No
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              name="generateUniqueDispenserNo"
                              placeholder="Dispenser Serial No."
                              value={dispenserSrNo}
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1"> Product Type </label>
                            <Field
                              placeholder="Select Product Type"
                              value={prodT}
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </Col>
                        
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Operation Type{" "}
                            </label>
                            <Field
                              name="oprationType"
                              className="form-control"
                              placeholder="Select OTP"
                              value={oprationType}
                              readOnly
                            />
                          </div>

                          {/* <div className="form-group mt-3 d-felx">
                            <button
                              type="button"
                              className="btn btn-warning  flex-grow-1"
                              onClick={HandleVerifyClickcalibrationstart}
                              disabled={!isVerifyButtonEnabled}
                            >
                              Verification
                            </button>
                            <h5 className="mt-3 redNote ">Note: Please scan dispenser before verify </h5>
                          </div> */}
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="lable mb-1">
                              {" "}
                              Sub Operation Type *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Sub Operation"
                                direction="bottom"
                              >
                                <Field
                                  name="subOprationType"
                                  className="form-control"
                                  placeholder="Select OTP"
                                  value={subOprationType}
                                  readOnly
                                />
                                {/* <Select
                                  name="subOprationType"
                                  placeholder="Select Operation"
                                  options={subOprationType}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "subOprationType",
                                      e.value
                                    );
                                  }}
                                /> */}
                              </ToolTip>
                            </div>
                            {/* <ErrorMessage
                              name="subOprationType"
                              component={TextError}
                            /> */}
                          </div>
                        </Col>
                        {/* {isVerifyEnabled && (
                          <> */}
                          <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">ARK NO *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter ARK no"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  // name="arkNo"
                                  required
                                  value={arkNo}
                                  placeholder="Enter ARK No."
                                  autoComplete="off"
                                  // onChange={(e) => setArkNo(e.target.value)}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^[A-Z0-9]*$/.test(value) && value.length <= 6) {
                                      setArkNo(value);
                                    }
                                  }}
                                />

                                {/* <Field
                                  type="text"
                                  className="form-control"
                                  value={arkNo}
                                  placeholder="Enter ARK No."
                                  autoComplete="off"
                                  onChange={handleArkChange}
                                /> */}

                              </ToolTip>
                            </div>
                           {/* {arkError && <div className="text-danger mt-1">{arkError}</div>} */}

                          </div>
                        </Col>
                         <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="LabelNew mb-1">
                                  {" "}
                                  Volume Totalizer *{" "}
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Enter Volume Totalizer"
                                    direction="bottom"
                                  >
                                    <Field
                                      type="text"
                                      className="form-control"
                                      // name="volumeTotalizer"
                                      placeholder="Enter Volume Totalizer"
                                      autoComplete="off"
                                      value={volumeTotalizer}
                                      // onChange={(e) => setVolumeTotalizer(e.target.value)}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*\.?\d*$/.test(value)) {
                                          setVolumeTotalizer(value);
                                        }
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="volumeTotalizer"
                                  component={TextError}
                                />
                              </div>
                            </Col> 
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="LabelNew mb-1">Job No * </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Enter Job No"
                                    direction="bottom"
                                  >
                                    <Field
                                      type="text"
                                      className="form-control"
                                      // name="jobNo"
                                      placeholder="Enter Job No."
                                      autoComplete="off"
                                      value={jobNo}
                                      // onChange={(e) => setJobNo(e.target.value)}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {
                                          setJobNo(value);
                                        }
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="jobNo"
                                  component={TextError}
                                />
                              </div>
                            </Col>
                            {/* <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="LabelNew mb-1">
                                  {" "}
                                  Inspector Name *{" "}
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Enter Inspector Name"
                                    direction="bottom"
                                  >
                                    <Field
                                      type="text"
                                      className="form-control"
                                      // name="inspectorName"
                                      placeholder="Enter Inspector Name"
                                      autoComplete="off"
                                      value={inspectorName}
                                      // onChange={(e) => setInspectorName(e.target.value)}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^[a-zA-Z\s]*$/.test(value)) {
                                          setInspectorName(value);
                                        }
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="inspectorName"
                                  component={TextError}
                                />
                              </div>
                            </Col> */}

                            {/* <Col md={6} className="mb-3">
                              

                              <div className="form-group">
                                <label className="LabelNew mb-1">Inspector Mobile No *</label>
                                <div className="example-wrapper">
                                  <ToolTip content="Enter Mobile No" direction="bottom">
                                    <Field
                                      type="text"
                                      maxLength="10"
                                      className={`form-control ${error ? 'is-invalid' : ''}`}
                                      placeholder="Enter Mobile No."
                                      autoComplete="off"
                                      value={inspectorMobileNo}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </ToolTip>
                                  {error && <div className="invalid-feedback">{error}</div>}
                                </div>
                                <ErrorMessage name="inspectorMobileNo" component="div" className="text-danger" />
                              </div>
                            </Col> */}

                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="LabelNew mb-1">Date *</label>
                                <br />
                                <div className="example-wrapper">
                                  <ToolTip content="Select Date" direction="bottom">
                                    <DatePicker
                                      showIcon
                                      closeOnScroll={true}
                                      selected={startDate}
                                      onChange={(date) => setStartDate(date)}
                                      className="form-control"
                                      dateFormat="dd-MMM-yyyy"
                                      placeholderText="Select Date"
                                    />
                                  </ToolTip>
                                </div>
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="LabelNew mb-1">Time *</label>
                                <br />
                                <div className="time-wrapper">
                                  <div className="allTime">
                                    <input
                                      type="time"
                                      onChange={handleTimeChange}
                                      className="form-control"
                                      step="1"
                                    />
                                  </div>
                                  <div className="addTime">
                                    <div className="example-wrapper">
                                      <ToolTip
                                        content="Select Time from Widget"
                                        direction="bottom"
                                      >
                                        <Field
                                          className="form-control"
                                          name="installationTime"
                                          placeholder="Select Time"
                                          value={displayFormattedTime}
                                          readOnly
                                        />
                                      </ToolTip>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">Site Type</label>
                                <Field
                                  name="siteType"
                                  className="form-control"
                                  readOnly
                                  value={siteT}
                                />
                              </div>
                            </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1"> RO Manager Name</label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="ro Manager Name"
                              readOnly
                              value={roManagerName}
                            />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1"> Ro Manager Email</label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Ro Manager Email"
                              readOnly
                              value={roManagerEmail}
                            />
                          </div>
                        </Col>

                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Ro Manager Mobile Number</label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Ro Manager Mobile"
                              readOnly
                              value={roManagerMobNo}
                            />
                          </div>
                        </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1"> Customer Name</label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  placeholder="Customer Name"
                                  readOnly
                                  value={customerNm}
                                />
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">
                                  {" "}
                                  Customer Mobile No
                                </label>
                                <Field
                                  type="text"
                                  maxLength="10"
                                  name="customerMobileNo"
                                  value={customerMblNo}
                                  className="form-control"
                                  placeholder="Customer Mobile No"
                                  readOnly
                                />
                              </div>
                            </Col>
                            {!(siteT === "COCO") && (
                              <Col md={6} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">Dealer Name</label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    placeholder="Dealer Name"
                                    value={dealerNm}
                                    readOnly
                                  />
                                </div>
                              </Col>
                            )}
                            {!(siteT === "COCO") && (
                              <Col md={6} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Dealer Mobile No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    maxLength="10"
                                    name="dealerMobileNo"
                                    value={dealerMblNo}
                                    className="form-control"
                                    placeholder="Dealer Mobile No"
                                    readOnly
                                  />
                                </div>
                              </Col>
                            )}
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">
                                  {" "}
                                  Service Engineer Name
                                </label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  placeholder="Service Engineer Name"
                                  readOnly
                                  value={serviceEngineerNm}
                                />
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">
                                  {" "}
                                  Service Engineer Mobile No
                                </label>
                                <Field
                                  type="text"
                                  maxLength="10"
                                  className="form-control"
                                  name="serviceEngineerMobNo"
                                  value={userMblNo}
                                  placeholder="Mobile No."
                                  readOnly
                                />
                              </div>

                              
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="LabelNew mb-1">
                                  Description *
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Enter Suitable Description"
                                    direction="bottom"
                                  >
                                    <Field
                                      as="textarea"
                                      rows="3"
                                      maxLength={100}
                                      className="form-control"
                                      // name="desc"
                                      value={Desc}
                                      placeholder="Enter Description"
                                      autoComplete="off"
                                      onChange={(e) => setDesc(e.target.value)}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage name="desc" component={TextError} />
                              </div>

                             
                            {/* </Col>
                             <Col md={6} > */}
                          
                           <div className="form-group mb-3  mt-5">
                                <button
                                  type="button"
                                  className="btn btn-info  flex-grow-1"
                                  onClick={HandleSendOtpcalistart}
                                  disabled={!isgetotpButtonEnabled || !isOtpdisable }
                                >
                                  {loadingbutton ? (
                                    <>

                                      <span className="ms-2">Please wait...</span>
                                    </>
                                  ) : (
                                    "Get OTP"
                                  )}
                                </button>


                              </div>

                              </Col>
                          {/* </>
                        )} */}
                        {isOtpEnabled && (
                          <>
                            <Col md={6} className="mb-3 ">
                            </Col>
                            <Col md={6} className="mb-3 ">
                              <div className="form-group">
                                <label className="Label mb-1">
                                  {" "}
                                  Upload Calibration Certificate Pdf 
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Upload Calibration Certificate"
                                    direction="bottom"
                                  >
                                    <input
                                      type="file"
                                      className="form-control"
                                      name="calibrationCertificate"
                                      placeholder="Upload Calibration Certificate Pdf"
                                      accept=".pdf"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "calibrationCertificate",
                                          e.currentTarget.files[0]
                                        );
                                        setCalibrationCertError('');
                                        calibrationCert(e);
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="calibrationCertificate"
                                  component={TextError}
                                />
                                {calibrationCertError && <p className="text-danger">{calibrationCertError}</p>}

                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">
                                  {" "}
                                  Certificate Date Photo {" "}
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Upload Certificate Date Photo"
                                    direction="bottom"
                                  >
                                    <input
                                      type="file"
                                      // accept=".xlsx, .xls, image/*, .doc, .docs, .txt, .pdf"
                                      className="form-control"
                                      name="certificateDatePhoto"
                                      placeholder="Certificate Date Photo"
                                      accept=".jpg, .jpeg, .png"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "certificateDatePhoto",
                                          e.currentTarget.files[0]
                                        );
                                        setCalibrationCertDateError('');
                                        certificateDatePhoto(e);
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="certificateDatePhoto"
                                  component={TextError}
                                />
                                {calibrationCertDateError && <p className="text-danger">{calibrationCertDateError}</p>}
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">
                                  {" "}
                                  Upload Certificate Signature Photo 
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Upload Certificate Signature"
                                    direction="bottom"
                                  >
                                    <input
                                      type="file"
                                      className="form-control"
                                      // accept=".xlsx, .xls, image/*, .doc, .docs, .txt, .pdf"
                                      name="certificateSignature"
                                      placeholder="Upload Certificate Signature Photo"
                                      accept=".jpg, .jpeg, .png"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "certificateSignature",
                                          e.currentTarget.files[0]
                                        );
                                        setCertificateSignatureError('')
                                        certificateSignature(e);
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="certificateSignature"
                                  component={TextError}
                                />
                                {CertificateSignatureError && <p className="text-danger">{CertificateSignatureError}</p>}
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">
                                  {" "}
                                  Digital Signature Photo {" "}
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Digital Signature"
                                    direction="bottom"
                                  >
                                    <input
                                      type="file"
                                      className="form-control"
                                      name="digitalSignature"
                                      placeholder="Digital Signature"
                                      accept=".jpg, .jpeg, .png"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "digitalSignature",
                                          e.currentTarget.files[0]
                                        );
                                        SetDigitalSignatureError('')
                                        digitalSignature(e);
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="digitalSignature"
                                  component={TextError}
                                />
                                {DigitalSignatureError && <p className="text-danger">{DigitalSignatureError}</p>}
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="lable mb-1">
                                  {" "}
                                  Upload Site Report Photo {" "}
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Upload Site Report"
                                    direction="bottom"
                                  >
                                    <input
                                      type="file"
                                      className="form-control"
                                      name="siteReportUpload"
                                      placeholder="Upload Site Report"
                                      accept=".jpg, .jpeg, .png"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "siteReportUpload",
                                          e.currentTarget.files[0]
                                        );
                                        SetUploadSitereporterror('')
                                        siteReportU(e);
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="siteReportUpload"
                                  component={TextError}
                                />
                                {UploadSitereporterror && <p className="text-danger">{UploadSitereporterror}</p>}
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Lable mb-1">
                                  {" "}
                                  Calibration Log View Photo {" "}
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Upload Calibration Log View"
                                    direction="bottom"
                                  >
                                    <input
                                      type="file"
                                      className="form-control"
                                      name="calibrationLogView"
                                      placeholder="Upload Calibration Log View"
                                      accept=".jpg, .jpeg, .png"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "calibrationLogView",
                                          e.currentTarget.files[0]
                                        );
                                        SetCalibrationLogViewPhoto('')
                                        calibrationLV(e);
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="calibrationLogView"
                                  component={TextError}
                                />
                                {CalibrationLogViewPhoto && <p className="text-danger">{CalibrationLogViewPhoto}</p>}
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="LabelNew mb-1">
                                  {" "}
                                  Upload Site Photo *{" "}
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Upload Site Photo"
                                    direction="bottom"
                                  >
                                    <input
                                      type="file"
                                      className="form-control"
                                      name="sitePhoto"
                                      placeholder="Upload Site Photo"
                                      accept=".jpg, .jpeg, .png"
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "sitePhoto",
                                          e.currentTarget.files[0]
                                        );
                                        Setsitephotoupload('')
                                        sitePhotoI(e);
                                      }}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="sitePhoto"
                                  component={TextError}
                                />
                                {sitephotoupload && <p className="text-danger">{sitephotoupload}</p>}
                              </div>
                            </Col>
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="LabelNew mb-1">
                                  {" "}
                                  Engineer Remark *{" "}
                                </label>
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Enter Remark"
                                    direction="bottom"
                                  >
                                    <Field
                                      as="textarea"
                                      className="form-control "
                                      rows="3"
                                      placeholder="Enter Remark"
                                      name="remark"
                                      maxLength={100}
                                    />
                                  </ToolTip>
                                </div>
                                <ErrorMessage
                                  name="remark"
                                  component={TextError}
                                />
                              </div>
                            </Col>

                            <Col>
                              <div className="form-group">
                                <button
                                  type="submit"
                                  className="btn btn-primary m-2 flex-grow-1"
                                  disabled={!iscalibrationstartcloseEnable || iscalibrationstartcloseEnables || isButtonDisabled}
                                >
                                  Close Calibration Start
                                </button>
                              </div>
                            </Col> 
                            
                            {/* <Col >
                              <div className="form-group mb-5">
                                <label htmlFor="closeCalibration" className="LabelNew" >Close Calibration Start</label><br />

                               
                                <label className="form-check-label m-1 ">
                                  <Field
                                    type="radio"
                                    name="submitRadio"
                                    value="no"
                                    onChange={() => HandleresetForm()}
                                  />
                                  <span style={{ marginLeft: '4px', color: 'red' }}>No</span>
                                </label>
                              </div>

                            </Col> */}
                          </>
                        )}
                      </Row>


                      {/* <Col > */}


                      {/* <div className="form-group">
                          <button
                            type="submit"
                            className="btn btn-primary m-2 flex-grow-1"
                            disabled={true} 
                          >
                        Close Calibration Start
                          </button>
                        </div> */}


                      {/* </Col> */}



                      {/* old Note commented bcz of new changes made in this form */}

                      {/* <h5 className="note">
                        Note :- Please scan the device and get the data from
                        dispenser.
                      </h5> */}



                      {/* -------------------------------------------------------- show hide calibration -----------------------
      ------------------------------------------------------------------------------------------------------- */}

                      <div className="main-form">
                        {/* //{show && Hide*/}
                        {show ? (
                          <>
                            <Form>
                              <hr />
                              <Row>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      {" "}
                                      Model Name
                                    </label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      value={processData.modelName}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <hr />
                              <h5
                                style={{ textAlign: "left", color: "#004417" }}
                              >
                                Motherboard (MCU)
                              </h5>
                              <Row>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      {" "}
                                      Firmware Version No{" "}
                                    </label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      value={processData.mcuBoardSoftwareSrNo}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      {" "}
                                      Hardware Version{" "}
                                    </label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      value={
                                        processData.mcuBoardHardwareVersion
                                      }
                                      readOnly
                                    />
                                  </div>
                                </Col>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      {" "}
                                      Board Serial No{" "}
                                    </label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      value={processData.mcuBoardSrNo}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-center">
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">SHA2</label>
                                    <Field
                                      type="password"
                                      className="form-control"
                                      value={processData.mcuBoardSHA2}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      {" "}
                                      Sign X-509-64 Bit Block{" "}
                                    </label>
                                    <Field
                                      type="password"
                                      className="form-control"
                                      value={processData.mcuBoardSignXBitBlock}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      Board Public Key
                                    </label>
                                    <Field
                                      type="password"
                                      className="form-control"
                                      value={processData.mcuBoardPublicKey}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      Board Private Key
                                    </label>
                                    <Field
                                      type="password"
                                      className="form-control"
                                      value={processData.mcuBoardPrivateKey}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      {" "}
                                      RCA Public Key{" "}
                                    </label>
                                    <Field
                                      type="password"
                                      className="form-control"
                                      value={processData.mcuBoardRCAPublicKey}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <hr />
                              <h5
                                style={{ textAlign: "left", color: "#004417" }}
                              >
                                Totalizer (TOT)
                              </h5>
                              <Row>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      Firmware Version No
                                    </label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      value={processData.memBoard1SoftwareSrNo}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      Hardware Version
                                    </label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      value={
                                        processData.memBoard1HardwareVersion
                                      }
                                      readOnly
                                    />
                                  </div>
                                </Col>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      Board Serial No
                                    </label>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      value={processData.memBoard1BoardSrNo}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-center">
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">SHA2</label>
                                    <Field
                                      type="password"
                                      className="form-control"
                                      value={processData.memBoard1BoardSHA2}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      Sign X-509-64 Bit Block
                                    </label>
                                    <Field
                                      type="password"
                                      className="form-control"
                                      value={processData.memBoard1SignXBitBlock}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      Board Public Key
                                    </label>
                                    <Field
                                      type="password"
                                      className="form-control"
                                      value={processData.memBoard1PublicKey}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      Board Private Key
                                    </label>
                                    <Field
                                      type="password"
                                      className="form-control"
                                      value={processData.memBoard1PrivateKey}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                                <Col md={4} className="mb-3">
                                  <div className="form-group">
                                    <label className="Label mb-1">
                                      RCA Public Key
                                    </label>
                                    <Field
                                      type="password"
                                      className="form-control"
                                      value={processData.memBoard1RCAPublicKey}
                                      readOnly
                                    />
                                  </div>
                                </Col>
                              </Row>
                              {csd?.map((obj, key) => (
                                <div key={key}>
                                  <hr />
                                  <h5
                                    style={{
                                      textAlign: "left",
                                      color: "#004417",
                                    }}
                                  >
                                    Customer Display (CSD-{key + 1})
                                  </h5>
                                  <Row>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Firmware Version No{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `csd${key + 1}BoardSoftwareSrNo`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Hardware Version{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `csd${key + 1
                                            }BoardHardwareVersion`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Serial No{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `csd${key + 1}BoardSrNo`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row className="align-items-center">
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          SHA2
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `csd${key + 1}BoardSHA2`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Sign X-509-64 Bit Block{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          id={`csdBoardSignXBitBlock${key + 1}`}
                                          value={
                                            processData[
                                            `csd${key + 1}BoardSignXBitBlock`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Public Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `csd${key + 1}BoardPublicKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Private Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `csd${key + 1}BoardPrivateKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          RCA Public Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `csd${key + 1}BoardPublicKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              ))}
                              {mre.map((obj, key) => (
                                <div key={key}>
                                  <hr />
                                  <h5
                                    style={{
                                      textAlign: "left",
                                      color: "#004417",
                                    }}
                                  >
                                    Pulser (MRE-{key + 1})
                                  </h5>
                                  <Row>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Firmware Version No{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `mre${key + 1}BoardSoftwareSrNo`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Hardware Version{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `mre${key + 1
                                            }BoardHardwareVersion`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Serial No{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `mre${key + 1}BoardSrNo`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row className="align-items-center">
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          SHA2
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `mre${key + 1}BoardSHA2`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Sign X-509-64 Bit Block{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `mre${key + 1}BoardSignXBitBlock`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Public Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `mre${key + 1}BoardRCAPublicKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Private Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `mre${key + 1}BoardPrivateKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          RCA Public Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `mre${key + 1}BoardRCAPublicKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              ))}
                              {lkd.map((obj, key) => (
                                <div key={key}>
                                  <hr />
                                  <h5
                                    style={{
                                      textAlign: "left",
                                      color: "#004417",
                                    }}
                                  >
                                    Operator Keypad Display (LKD-{key + 1})
                                  </h5>
                                  <Row>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          Firmware Version No
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `lkd${key + 1}BoardSoftwareSrNo`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          Hardware Version
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `lkd${key + 1
                                            }BoardHardwareVersion`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Serial No{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `lkd${key + 1}BoardSrNo`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row className="align-items-center">
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          SHA2
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `lkd${key + 1}BoardSHA2`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Sign X-509-64 Bit Block{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `lkd${key + 1}BoardSignXBitBlock`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Public Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `lkd${key + 1}BoardPublicKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          Board Private Key
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `lkd${key + 1}BoardPrivateKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          RCA Public Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `lkd${key + 1}BoardRCAPublicKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              ))}
                              {/* ----------------------------------------------------------------  Vapor Recovery (VR)  */}
                              {pvr.map((obj, key) => (
                                <div key={key}>
                                  <hr />
                                  <h5
                                    style={{
                                      textAlign: "left",
                                      color: "darkblue",
                                    }}
                                  >
                                    Vapor Recovery (VR-{key + 1})
                                  </h5>
                                  <Row>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Firmware Version No{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `pvr${key + 1}BoardSoftwareSrNo`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Hardware Version{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `pvr${key + 1}BoardHardwareVersion`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Serial No{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[`pvr${key + 1}BoardSrNo`]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">SHA2</label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[`pvr${key + 1}BoardSHA2`]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Sign X-509-64 Bit Block{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `pvr${key + 1}BoardSignXBitBlock`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Public Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `pvr${key + 1}BoardPublicKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Private Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `pvr${key + 1}BoardPrivateKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          RCA Public Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `pvr${key + 1}BoardRCAPublicKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              ))}
                              {/* ---------------------------------------------------------------- Printer (Printer) */}
                              {prn.map((obj, key) => (
                                <div key={key}>
                                  <hr />
                                  <h5
                                    style={{
                                      textAlign: "left",
                                      color: "darkblue",
                                    }}
                                  >
                                    Printer (Printer-{key + 1})
                                  </h5>
                                  <Row>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Firmware Version No{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `prn${key + 1}BoardSoftwareSrNo`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Hardware Version{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[
                                            `prn${key + 1}BoardHardwareVersion`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Serial No{" "}
                                        </label>
                                        <Field
                                          type="text"
                                          className="form-control"
                                          value={
                                            processData[`prn${key + 1}BoardSrNo`]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">SHA2</label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[`prn${key + 1}BoardSHA2`]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Sign X-509-64 Bit Block{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `prn${key + 1}BoardSignXBitBlock`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Public Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `prn${key + 1}BoardPublicKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          Board Private Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `prn${key + 1}BoardPrivateKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                    <Col md={4} className="mb-3">
                                      <div className="form-group">
                                        <label className="Label mb-1">
                                          {" "}
                                          RCA Public Key{" "}
                                        </label>
                                        <Field
                                          type="password"
                                          className="form-control"
                                          value={
                                            processData[
                                            `prn${key + 1}BoardRCAPublicKey`
                                            ]
                                          }
                                          readOnly
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              ))}
                            </Form>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Form>
                  </>
                ) : (
                  <></>
                )}
              </Card.Body>
            </Card>
          </>
        );
      }}
    </Formik>
  );
};


// above code is orinal form of calibration

// below code for new requirement of 1 work order can handle multiple nozzels

// import * as Yup from "yup";

// import { Button, Card, Col, Row } from "@themesberg/react-bootstrap";
// import { ErrorMessage, Field, Form, Formik } from "formik";
// import React, { useEffect, useState } from "react";
// import {
//   getAllDataOfDispenserSrNo,
//   getCalibrationDetailsGetData,

//   postCalibrationstartDetailscloseofimages,
//   postGetotpDetailscalistart
// } from "../../Service/AllServicesAPI";
// import { postEndingcloseCalibration, postGetotpDetailscaliEnd } from "../../Service/AllServicesAPI";
// import { fetchOtp, deleteOtp } from "../../Service/AllProductionAPI"
// import {
//   getCustomerList,
//   getDealerList,
//   getServiceEngineerList,
// } from "../master/AllUserDropDown";

// import DatePicker from "react-datepicker";
// import EndingARKCalibration from "./EndingARKCalibration";
// // import NotScanned from "../NotScanned";
// import Select from "react-select";
// import Swal from "sweetalert2";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faAngleLeft, faBackward } from "@fortawesome/free-solid-svg-icons";

// import TextError from "../TextError";
// import ToolTip from "../ToolTip";
// import moment from "moment-timezone";
// import swal from "sweetalert";
// import { useLocation, Link } from "react-router-dom";
// import Toast from 'react-bootstrap/Toast';
// // import OtpFormBased from "../../components/OtpFormBased";


// export default () => {
//   const [show, setShow] = useState(false);
//   const [showM, setShowM] = useState(false);
//   const handleShow = () => setShowM(true);
//   const handleClose = () => setShowM(false);
//   const [customerName, setCustomerName] = useState([]);
//   const [csd, setCsd] = useState([1]);
//   const [mre, setMre] = useState([1]);
//   const [lkd, setLkd] = useState([1]);
//   // newly added board vr and printer
//   const [pvr, setPvr] = useState([1]);
//   const [prn, setPrn] = useState([1]);

//   const location = useLocation();
//   const [workOrder, setWorkOrder] = useState("");
//   const [role, setRole] = useState(sessionStorage.getItem("role"));
//   const [processData, setProcessData] = useState([]);
//   const [dispenserSrNo, setDispenserSrNo] = useState("");
//   let type = null;
//   const [selectedCustomerId, setSelectedCustomerId] = useState("");
//   const [customerMblNo, setCustomerMblNo] = useState("");
//   const [dealerNm, setDealerNm] = useState("");
//   const [customerNm, setCustomerNm] = useState("");
//   const [oprationType, setOprationType] = useState("");
//   const [oprationTypes, setOprationTypes] = useState("End Calibration");
//   const [subOprationType, setSubOprationType] = useState("");

//   const [serviceEngineerNm, setServiceEngineerNm] = useState("");
//   const [serviceEngineerId, setServiceEngineerId] = useState("");
//   const [siteT, setSiteT] = useState("");
//   const [Desc, setDesc] = useState("");
//   const [userMblNo, setUserMblNo] = useState("");
//   const [dealerId, setDealerId] = useState([]);
//   const [dealerMblNo, setDealerMblNo] = useState("");
//   let today = new Date();
//   let todayDate =
//     today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
//   console.log("todayDate :-", todayDate);
//   const [dealerName, setDealerName] = useState([]);
//   const [serviceEngineerName, setServiceEngineerName] = useState([]);
//   const [isLoaded, setisLoaded] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [newData, setNewData] = useState("");
//   const [curreLocation, setCurreLocation] = useState({});
//   const [prodT, setProdT] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [selectedTime, setSelectedTime] = useState("");
//   const [startDate, setStartDate] = useState(new Date());
//   const [disabled, setDisabled] = useState(false);


//   const [arkNo, setArkNo] = useState("");
  
//   const [volumeTotalizer, setVolumeTotalizer] = useState("");
//   const [jobNo, setJobNo] = useState("");
//   const [inspectorName, setInspectorName] = useState("");
//   const [inspectorMobileNo, setInspectorMobileNo] = useState("");
//   const [error, setError] = useState('');
//   const [closeComp, SetCloseComp] = useState(true);
//   // loading text in button 
//   const [loadingbutton, setLoadingbutton] = useState(false);
//   // verify  and upload image form toggle states
//   const [isVerifyEnabled, setVerifyEnabled] = useState(true);
//   const [isOtpEnabled, setOtpEnabled] = useState(true);

//   // disable and enable get otp button after 1 minutues
//   const [isOtpdisable, setOtpdisable] = useState(true);


//   const [CloseCalibutton, setCloseCalibutton] = useState(false)

//   const [isButtonDisabled, setIsButtonDisabled] = useState(false);

//   const [otpData, setOtpData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [showToast, setShowToast] = useState(true);

//   const [nozzles, setNozzles] = useState([]);
//   const [selectedNozzle, setSelectedNozzle] = useState("");


//   const [subOperationList, setSubOperationList] = useState([]);


//   const [isclosecalibtarionButtonEnabled, SetisclosecalibtarionButtonEnabled] = useState(false);
//   const [iscalibrationbutton, setiscalibrationbutton] = useState(false);




//   useEffect(() => {
//     // API se aaya hua data
//     setNozzles(["Nozzle 1", "Nozzle 2", "Nozzle 3"]);
//   }, []);

//   useEffect(() => {
//     document.addEventListener("keydown", function (event) {
//       if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
//         var form = event.target.form;
//         var index = Array.prototype.indexOf.call(form, event.target);
//         form.elements[index + 1].focus();
//         event.preventDefault();
//       }
//     });
//   }, []);

//   const handleTimeChange = (e) => {
//     setSelectedTime(e.target.value);
//   };

//   const formatTimeTo12Hour = (time24) => {
//     const [hour, minute, second] = time24.split(":");
//     const parsedHour = parseInt(hour, 10);
//     const period = parsedHour >= 12 ? "PM" : "AM";
//     const formattedHour = parsedHour > 12 ? parsedHour - 12 : parsedHour;
//     return `${formattedHour}:${minute}:${second} ${period}`;
//   };

//   const displayFormattedTime = selectedTime
//     ? formatTimeTo12Hour(selectedTime)
//     : "";

//   const modalToggle = () => {
//     setShowModal(handleShow);
//   };

//   useEffect(() => {
//     // Function call to get customers,Dealers and  Service Engineers list
//     getCustomersList();
//     getServiceEngineersList();
//     getDealersList();
//     getCalibrationAllDetails();

//     if (role === "service engineer") {
//       const { data } = location.state;
//       setWorkOrder(data.workOrderSerialNo);
//       setDispenserSrNo(data.generateUniqueDispenserNo);
//       // getDataScanOrNot(data.generateUniqueDispenserNo);
//       getDataDispenSrNo(data.generateUniqueDispenserNo);
//       setCustomerNm(data.customerName); //siteType
//       setCustomerMblNo(data.customerMobNo);
//       setServiceEngineerNm(data.serviceEngineerName);
//       setUserMblNo(data.serviceEngineerMobNo);
//       setDealerNm(data.dealerName);
//       setDealerMblNo(data.dealerMobNo);
//       setServiceEngineerId(data.fkServiceEngineerId);
//       setSelectedCustomerId(data.fkCustomerId);
//       setDealerId(data.fkDealerId);
//       setSiteT(data.siteType);
//       setOprationType(data.oprationType);
//       setSubOprationType(data.subOprationType);
//       if (data.subOprationType) {
//         const list = Array.isArray(data.subOprationType)
//           ? data.subOprationType
//           : data.subOprationType.split(",");

//         setSubOperationList(list.map(n => n.trim()));
//       }

//     }
//   }, []);





//   const validateMobile = (value) => {
//     let error;
//     if (!value) {
//       error = "Mobile number is required";
//     } else if (!/^[0-9\s]+$/.test(value)) {
//       error = "Enter numbers only";
//     } else {
//       const cleanedNumber = value.replace(/\s/g, ""); // Remove spaces
//       if (!/^\d{10}$/.test(cleanedNumber)) {
//         error = "Mobile number must be exactly 10 digits";
//       } else if (!/^[6-9]\d{9}$/.test(cleanedNumber)) {
//         error = "Invalid mobile number";
//       }
//     }
//     return error;
//   };

//   const handleChange = (e) => {
//     const value = e.target.value;
//     setInspectorMobileNo(value);
//     const validationError = validateMobile(value);
//     setError(validationError);
//   };

//   const handleBlur = () => {
//     const validationError = validateMobile(inspectorMobileNo);
//     setError(validationError);
//   };

//   // Function declaration of get customers list
//   const getCustomersList = async () => {
//     await getCustomerList().then((result) => {
//       setCustomerName(result);
//     });
//   };
//   // Function declaration of get Service Engineers list
//   const getServiceEngineersList = async () => {
//     await getServiceEngineerList().then((result) => {
//       setServiceEngineerName(result);
//     });
//   };

//   const getDealersList = async () => {
//     await getDealerList().then((result) => {
//       setDealerName(result);
//     });
//   };

//   const getCalibrationAllDetails = async () => {
//     const token = sessionStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${token}` };
//     const { data } = location.state;
//     let workOSNo = data.workOrderSerialNo;
//     await getCalibrationDetailsGetData(workOSNo, headers)
//       .then((result) => {
//         console.log(
//           "getCalibrationDetailsGetData result for check :-",
//           result.data
//         );
//         if (result.data.digitalSignature) {  // addes new digitalsignature for validation
//           setNewData(result.data);
//           modalToggle();
//         }
//       })
//       .catch((error) => {
//         console.log("getCalibrationDetailsGetData error for check :-", error);
//       });
//   };





//   const getDataDispenSrNo = (disSrNo) => {
//     const token = sessionStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${token}` };
//     console.log("dispenserSrNo :-", disSrNo);
//     getAllDataOfDispenserSrNo(disSrNo, headers)
//       .then((result) => {
//         console.log("getAllDataOfDispenSrNo result :-", result);
//         setProdT(result.data.productType);
//       })
//       .catch((error) => {
//         console.log("getAllDataOfDispenSrNo error :-", error);
//       });
//   };









//   const token = sessionStorage.getItem("token");
//   const fkUserId = sessionStorage.getItem("pkUserId");

//   const fetchOtpFromApi = async () => {
//     if (!fkUserId || !token) {
//       console.error("Missing fkUserId or token in sessionStorage.");
//       return;
//     }

//     try {
//       setLoading(true);
//       const fetchedData = await fetchOtp(fkUserId, token);
//       console.log("Fetched OTP Data (Navbar):", fetchedData);

//       if (fetchedData?.otp) {
//         setOtpData(fetchedData);
//       } else {
//         setOtpData(null);
//         console.warn("No OTP data found.");
//       }
//     } catch (error) {
//       console.error("Error fetching OTP:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // new get otp without delay response and please wait popup message
//   const HandleSendOtpcalistart = async () => {
//     console.log("ARK no. checking", arkNo);

//     setLoadingbutton(true)
//     const token = sessionStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${token}` };

//     const payload = {
//       workOrderSerialNo: workOrder,
//       productType: prodT,
//       generateUniqueDispenserNo: dispenserSrNo,
//       arkNo: arkNo,
//       oprationType: oprationType,
//       // subOprationType: subOprationType,
//       subOprationType: selectedNozzle,
//       volumeTotalizer: volumeTotalizer,
//       jobNo: jobNo,
//       inspectorName: inspectorName,
//       inspectorMobileNo: inspectorMobileNo,
//       calibrationDate: moment(startDate, "yyyy-MM-DD").format("yyyy-MM-DD"),
//       calibrationTime: moment(displayFormattedTime, "hh:mm:ss A").format("hh:mm:ss A"),
//       fkCustomerId: selectedCustomerId,
//       customerName: customerNm,
//       customerMobileNo: customerMblNo,
//       siteType: siteT,
//       fkDealerId: dealerId,
//       dealerName: dealerNm,
//       description: Desc,
//       dealerMobileNo: dealerMblNo,
//       fkServiceEngineerId: serviceEngineerId,
//       serviceEngineerName: serviceEngineerNm,
//       serviceEngineerMobNo: userMblNo,
//       longitude: curreLocation.longitude,
//       latitude: curreLocation.latitude,
//     };

//     setOtpdisable(true);


//     try {
//       const response = await postGetotpDetailscalistart(payload, headers);



//       const { message, status } = response.data;

//       if (status === 200) {
//         if (message === "First Generate ARK ON Dispenser Then, SCAN.") {
//           swal("", message, "info");
//         } else if (message === "Scanning Required..") {
//           swal("", message, "warning");
//         }
//         else if (message === "ARK verification Failed") {
//           swal("Failed", message, "error");
//         }
//         else if (message === "dispenser data is not scanned for this work order calibration 1") {
//           swal("", "Dispenser data is not scanned for this work order", "error");
//         }
//         else if (message === "PKI Server is down..") {
//           swal("", "PKI Server is down..", "info");
//         }
//         else if (message === "INVALID Operation Type And SubOperation Type..") {
//           swal("Warning", "INVALID Operation Type And SubOperation Type..", "warning");
//         }
//         else if (message === "Calibration details job Work Order is Not Valid") {
//           swal("Failed", "Calibration details job Work Order is Not Valid", "error");
//         }
//         else if (message === "Your Scanning for wrong Dispenser Serial Number..") {
//           swal("", "Your Scanning for wrong Dispenser Serial Number...", "error");
//         } else if (message === "Calibration details added successfully") {
//           swal("Great", "Calibration details added successfully", "success");


//           fetchOtpFromApi()
//           setOtpEnabled(true);
//           setOtpdisable(false);

//           setLoadingbutton(false)
//           setTimeout(() => {
//             setOtpdisable(true);
//           }, 60000);
//         } else {
//           swal("Error", "Unexpected response message", "error");
//         }
//       } else {
//         swal("Error", "Unexpected status code", "error");
//       }
//     } catch (error) {

//       console.log("Error sending OTP:", error);
//       swal("Failed", "Error sending OTP", "error");
//     }
//     finally {

//       setLoadingbutton(false)
//     }
//   };


//   const handleDeleteOtp = async () => {
//     if (!otpData?.pkFieldotpId) {
//       console.error("OTP ID not found.");
//       return;
//     }

//     try {
//       setLoading(true);
//       const result = await deleteOtp(otpData.pkFieldotpId);

//       if (result.success) {
//         console.log("OTP deleted successfully.");
//         setOtpData(null); // Remove from UI
//       } else {
//         alert("Failed to delete OTP.");
//       }
//     } catch (error) {
//       console.error("Error deleting OTP:", error);
//     } finally {
//       setLoading(false);
//     }
//   };





//   // submiting the calibration start form with images,pdf, dispesner number and workorder serial number

//   const Handlesubmitcalistart = async (values, { resetForm }) => {
//     try {
//       setDisabled(true);
//       // payload 
//       let data = {
//         workOrderSerialNo: workOrder,
//         generateUniqueDispenserNo: dispenserSrNo,

//         remark: values.remark,
//       };
//       console.log("getCalibrationDispenser data :-", data);
//       let token = sessionStorage.getItem("token");
//       let headers = { Authorization: `Bearer ${token}` };



//       await postCalibrationstartDetailscloseofimages(data, headers)
//         .then((result) => {
//           console.log("postCalibrationDetails result :-", result);
//           setisLoaded(false);

//           const message = result.data.message;

//           if (message === "Data saved..") {
//             swal("Great", "Data saved successfully..", "success");
//             handleDeleteOtp()
//             SetCloseComp(false)
//             setIsButtonDisabled(true);
//             setTimeout(() => {
//               // window.location.href = "serviceModule/verification-calibration-list";
//               window.location.reload()
//             }, 3000);


//           } else {
//             swal("Failed", "Wrong data entered...", "error");
//             setCloseCalibutton(true)

//           }

//         })
//         .catch((error) => {
//           console.log("postCalibrationDetails error :-", error);
//           setisLoaded(false);
//           if (error.response.status === 400) {
//             swal("Failed", `${error.response.data.message}`, "error");
//           } else if (error.response.data.status === 500) {
//             swal("Failed", `${error.response.data.message}`, "error");

//           } else {
//             swal("Failed", "Failed to close Calibration start", "error");
//           }
//         });
//     } catch (error) {
//       console.log(error);
//       swal("Failed", "Something went wrong", "error");
//       setCloseCalibutton(true)
//     }
//   }



//   const handleEndingCalibration = async (resetForm,) => {
//     try {
//       const data = {
//         generateUniqueDispenserNo: dispenserSrNo,
//       };

//       const token = sessionStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${token}` };

//       const result = await postEndingcloseCalibration(data, headers);
//       console.log("Add Ending ARK Data", result);

//       const message = result.data.message;

//       if (message === "ARK Ending Varification Failed" || message === "Ending ARK verification Failed") {
//         swal("Failed", "End ARK verification failed", "error");
//       } else if (message === "Calibration details job Work Order is Not Valid ") {
//         swal("", "Calibration details job Work Order is not valid", "warning");
//       } else if (message === "Work Order Closed..") {
//         swal("Great", "Calibration work order closed successfully", "success");
//         handleDeleteOtp(); // OTP delete function call
//         SetCloseComp(false); // update state
//         setiscalibrationbutton(true); // enable button if needed
//         console.log(message);
//       }

//       resetForm(); // reset Formik form

//       setTimeout(() => {
//         handleClose(); // close modal after 7 seconds
//       }, 7000);

//     } catch (error) {
//       console.log("Ending ARK Error :-", error);
//       if (error?.response?.status === 400) {
//         swal("Failed", `${error.response.data.message}`, "error");
//       }
//     }
//   };


//   const HandleSendOtpcaliend = async () => {
//     console.log("ARK no. checking", arkNo);
//     setLoadingbutton(true)
//     const token = sessionStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${token}` };

//     const payload = {
//       generateUniqueDispenserNo: dispenserSrNo,
//       arkNo: arkNo,
//       oprationTypes: oprationTypes,
//       // subOprationType: subOprationType,
//       subOprationType: selectedNozzle,
//       volumeTotalizer: volumeTotalizer,
//     };


//     setOtpdisable(true);

//     try {

//       const response = await postGetotpDetailscaliEnd(payload, headers);

//       const { message, status } = response.data;

//       if (status === 200) {
//         if (message === "First Generate ARK ON Dispenser Then, SCAN.") {
//           swal("Info", message, "info");
//         } else if (message === "Scanning Required..") {
//           swal("", message, "warning");
//         } else if (message === "Ending ARK verification Failed") {
//           swal("", "Ending ARK verification Failed", "error");
//         } else if (message === "ARK Ending Varification Failed") {
//           swal("", "ARK Ending Verification Failed", "error");
//         } else if (message === "Calibration details added successfully") {
//           swal("Great", "Calibration end details added successfully", "success");

//           fetchOtpFromApi();
//           setOtpdisable(false);
//           setLoadingbutton(true)
//           setTimeout(() => {
//             setOtpdisable(true);
//           }, 120000);

//           SetisclosecalibtarionButtonEnabled(true);
//         } else {
//           swal("Failed", "Unexpected response message", "error");
//         }
//       } else {
//         swal("Error", "Unexpected status code", "error");
//       }
//     } catch (error) {

//       console.log("Error sending OTP:", error);
//       swal("Failed", "Failed to send OTP", "error");
//     }
//     finally {

//       setLoadingbutton(false)
//     }
//   };


//   return (
//     <Formik
//       initialValues={{
//         workOrderSerialNo: "",
//         generateUniqueDispenserNo: "",
//         calibrationCertificate: "",
//         certificateDatePhoto: "",
//         certificateSignature: "",
//         digitalSignature: "",
//         siteReportUpload: "",
//         calibrationLogView: "",
//         sitePhoto: "",
//         remark: "",
//       }}
//       // validationSchema={validationSchema}
//       onSubmit={Handlesubmitcalistart}

//     >
//       {(formik) => {
//         const { isValid, dirty, isSubmitting, handleSubmit, values } = formik;
//         // const isVerifyButtonEnabled = arkNo;

//         return (
//           <>
//             {showM && (
//               <EndingARKCalibration
//                 status={showM}
//                 handleClose={handleClose}
//                 someData={newData}

//               />
//             )}
//             <div className="d-flex mb-2">
//               <Link
//                 to="verification-calibration-list"
//                 className="fieldLink btn btn-primary"
//               >
//                 <FontAwesomeIcon icon={faAngleLeft} className="me-2" />{" "}
//                 My Jobs
//                 <span className="icon icon-small ms-1"></span>
//               </Link>
//             </div>
//             <Card border="light" className="bg-white shadow-sm mb-4">
//               <Card.Body>
//                 {!showM ? (
//                   <>

//                     <h5 className="head mb-4">Calibration Start</h5>

//                     <Form>
//                       <Row>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Work Order No.
//                             </label>
//                             <Field
//                               type="text"
//                               className="form-control"
//                               name="workOrderNo"
//                               placeholder="Work Order No."
//                               value={workOrder}
//                               readOnly
//                             />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Dispenser Serial No
//                             </label>
//                             <Field
//                               type="text"
//                               className="form-control"
//                               name="generateUniqueDispenserNo"
//                               placeholder="Dispenser Serial No."
//                               value={dispenserSrNo}
//                               readOnly
//                             />
//                           </div>
//                         </Col>

//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">ARK NO *</label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Enter ARK no"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   type="text"
//                                   className="form-control"
//                                   // name="arkNo"
//                                   required
//                                   value={arkNo}
//                                   placeholder="Enter ARK No."
//                                   autoComplete="off"
//                                   // onChange={(e) => setArkNo(e.target.value)}
//                                   onChange={(e) => {
//                                     const value = e.target.value;
//                                     if (/^[A-Z0-9]*$/.test(value) && value.length <= 6) {
//                                       setArkNo(value);
//                                     }
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage name="arkNo" component={TextError} />
//                           </div>
//                         </Col>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Operation Type{" "}
//                             </label>
//                             <Field
//                               name="oprationType"
//                               className="form-control"
//                               placeholder="Select OTP"
//                               value={oprationType}
//                               readOnly
//                             />
//                           </div>


//                         </Col>
//                         {/* <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="lable mb-1">
//                               {" "}
//                               Sub Operation Type *{" "}
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Sub Operation"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   name="subOprationType"
//                                   className="form-control"
//                                   placeholder="Select OTP"
//                                   value={subOprationType}
//                                   readOnly
//                                 />

//                               </ToolTip>
//                             </div>

//                           </div>
//                         </Col> */}

//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="lable mb-1">
//                               Sub Operation Type *
//                             </label>

//                             <div className="example-wrapper">
//                               <ToolTip content="Select Nozzle" direction="bottom">
//                                 <Field
//                                   as="select"
//                                   name="subOprationType"
//                                   className="form-control"
//                                   value={selectedNozzle}
//                                   onChange={(e) => {
//                                     setSelectedNozzle(e.target.value);
//                                     formik.setFieldValue("subOprationType", e.target.value);
//                                   }}
//                                 >
//                                   <option value="">Select Nozzle</option>
//                                   {subOperationList.map((nozzle, index) => (
//                                     <option key={index} value={nozzle}>
//                                       {nozzle}
//                                     </option>
//                                   ))}
//                                 </Field>

//                               </ToolTip>
//                             </div>
//                           </div>
//                         </Col>


//                         {isVerifyEnabled && (
//                           <>
//                             <Col md={6} className="mb-3">
//                               <div className="form-group">
//                                 <label className="LabelNew mb-1">
//                                   {" "}
//                                   Volume Totalizer *{" "}
//                                 </label>
//                                 <div className="example-wrapper">
//                                   <ToolTip
//                                     content="Enter Volume Totalizer"
//                                     direction="bottom"
//                                   >
//                                     <Field
//                                       type="text"
//                                       className="form-control"
//                                       // name="volumeTotalizer"
//                                       placeholder="Enter Volume Totalizer"
//                                       autoComplete="off"
//                                       value={volumeTotalizer}
//                                       // onChange={(e) => setVolumeTotalizer(e.target.value)}
//                                       onChange={(e) => {
//                                         const value = e.target.value;
//                                         if (/^\d*\.?\d*$/.test(value)) {
//                                           setVolumeTotalizer(value);
//                                         }
//                                       }}
//                                     />
//                                   </ToolTip>
//                                 </div>
//                                 <ErrorMessage
//                                   name="volumeTotalizer"
//                                   component={TextError}
//                                 />
//                               </div>
//                             </Col>





//                             <Col md={6} className="mb-3">

//                               <div className="form-group mt-3">
//                                 <button
//                                   type="button"
//                                   className="btn btn-info  flex-grow-1"
//                                   onClick={HandleSendOtpcalistart}

//                                 >
//                                   {loadingbutton ? (
//                                     <>

//                                       <span className="ms-2">Please wait...</span>
//                                     </>
//                                   ) : (
//                                     "Get OTP"
//                                   )}
//                                 </button>


//                               </div>
//                             </Col>


//                           </>
//                         )}


//                         <Col>
//                           <div className="form-group">
//                             <button
//                               type="submit"
//                               className="btn btn-primary m-2 flex-grow-1"

//                             >
//                               Close Calibration Start
//                             </button>
//                           </div>
//                         </Col>

//                         <Col >

//                         </Col>
//                         <hr />

//                         <h5 className="head mb-4">Calibration End form</h5>
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">ARK NO *</label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Enter ARK no"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   type="text"
//                                   className="form-control"
//                                   // name="arkNo"
//                                   required
//                                   value={arkNo}
//                                   placeholder="Enter ARK No."
//                                   autoComplete="off"
//                                   // onChange={(e) => setArkNo(e.target.value)}
//                                   onChange={(e) => {
//                                     const value = e.target.value;
//                                     if (/^[A-Z0-9]*$/.test(value) && value.length <= 6) {
//                                       setArkNo(value);
//                                     }
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage name="arkNo" component={TextError} />
//                           </div>
//                         </Col>

//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Dispenser Serial No
//                             </label>
//                             <Field
//                               type="text"
//                               className="form-control"
//                               name="generateUniqueDispenserNo"
//                               placeholder="Dispenser Serial No."
//                               value={dispenserSrNo}
//                               readOnly
//                             />
//                           </div>
//                         </Col>

//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="Label mb-1">
//                               {" "}
//                               Operation Type{" "}
//                             </label>
//                             <Field
//                               name="oprationTypes"
//                               className="form-control"
//                               placeholder="Select OTP"
//                               value="End Calibration"
//                               readOnly
//                             />
//                           </div>


//                         </Col>
//                         {/* <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="lable mb-1">
//                               {" "}
//                               Sub Operation Type *{" "}
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Select Sub Operation"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   name="subOprationType"
//                                   className="form-control"
//                                   placeholder="Select OTP"
//                                   value={subOprationType}
//                                   readOnly
//                                 />

//                               </ToolTip>
//                             </div>

//                           </div>
//                         </Col>
//  */}


//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="lable mb-1">
//                               Sub Operation Type *
//                             </label>

//                             <div className="example-wrapper">
//                               <ToolTip content="Select Nozzle" direction="bottom">
//                                 <Field
//                                   as="select"
//                                   name="subOprationType"
//                                   className="form-control"
//                                   value={selectedNozzle}
//                                   onChange={(e) => {
//                                     setSelectedNozzle(e.target.value);
//                                     formik.setFieldValue("subOprationType", e.target.value);
//                                   }}
//                                 >
//                                   <option value="">Select Nozzle</option>
//                                   {subOperationList.map((nozzle, index) => (
//                                     <option key={index} value={nozzle}>
//                                       {nozzle}
//                                     </option>
//                                   ))}
//                                 </Field>

//                               </ToolTip>
//                             </div>
//                           </div>
//                         </Col>


//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">
//                               {" "}
//                               Volume Totalizer *{" "}
//                             </label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Enter Volume Totalizer"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   type="text"
//                                   className="form-control"
//                                   // name="volumeTotalizer"
//                                   placeholder="Enter Volume Totalizer"
//                                   autoComplete="off"
//                                   value={volumeTotalizer}
//                                   // onChange={(e) => setVolumeTotalizer(e.target.value)}
//                                   onChange={(e) => {
//                                     const value = e.target.value;
//                                     if (/^\d*\.?\d*$/.test(value)) {
//                                       setVolumeTotalizer(value);
//                                     }
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage
//                               name="volumeTotalizer"
//                               component={TextError}
//                             />
//                           </div>
//                         </Col>

//                         <Col md={6} className="mb-3 d-flex flex-wrap">


//                           <div className="form-group">
//                             <button
//                               type="button"
//                               className="btn btn-info m-2 flex-grow-1"
//                               onClick={HandleSendOtpcaliend}

//                             >
//                               {loadingbutton ? (
//                                 <>

//                                   <span className="ms-2">Please wait...</span>
//                                 </>
//                               ) : (
//                                 "Get OTP"
//                               )}
//                             </button>
//                           </div>

//                         </Col>



//                         <Col md={6} className="mb-3 d-flex flex-wrap">
//                           <div className="form-group">
//                             <button
//                               type="button"
//                               className="btn btn-primary m-2 flex-grow-1"
//                               onClick={handleEndingCalibration}

//                             >
//                               Close Calibration Work Oder
//                             </button>
//                           </div>
//                         </Col>
//                       </Row>


//                     </Form>
//                   </>
//                 ) : (
//                   <></>
//                 )}
//               </Card.Body>
//             </Card>
//           </>
//         );
//       }}
//     </Formik>
//   );
// };
